<div class="contact-container body-content-area" #container>
    <table class="procurement-rate-agreement">
        <tr class="header-area">
            <td colspan="7" class="sub-title">TRANSPORTATION PROCUREMENT RATE AGREEMENT</td>
        </tr>
        <tr>
            <td colspan="5"></td><td class="confidential">CONFIDENTIAL</td>
        </tr>
        <tr>
            <td colspan="7" class="service-contract">Part I of Service Contract (Effective Date: {{ data.InitialContractEffectiveDate | date:'dd/MM/yyyy' }})</td>
        </tr>
        <tr></tr>
        
        <tr>
            <td colspan="2">{{data.Name}}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Rate Agreement Nº (ID): {{ data.RateAgreementNumber }}</td>
        </tr>

        <tr>
            <td colspan="2">GSDB: {{data.GSDB}}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Revision Number: {{data.RevisionNumber }}</td>
        </tr>

        <tr>
            <td colspan="2">{{data.Street}}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Initial Contract Effective Date: {{ data.InitialContractEffectiveDate | date:'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
            <td colspan="2">{{data.City}}, {{data.Postcode}}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Effective Date: {{ data.EffectiveDate | date:'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
            <td colspan="2">{{data.Country}}</td>
            <td></td><td></td><td></td>
            
            <td colspan="2">Expiry Date: {{ data.ExpiryDate | date:'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
            <!-- <td colspan="1">{{data.Postcode}}</td> -->
            <td></td><td></td><td></td><td></td><td></td>
            <td colspan="2">Reason for Revision: {{ appService.deResingDoubleQuotess(data.ReasonforRevision) }}</td>
        </tr>

        <!---space-->
        <tr></tr>
        <tr>
            <td colspan="2">Telephone: {{ data.Telephone }}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Supersedes RA Nº (ID): {{ data.SupersedesRANo }}</td>
        </tr>

        <tr>
            <td colspan="2">E-mail: {{ data.Email }}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Payment Terms: {{ data.PaymentTerms }} Days</td>
        </tr>

        <tr>
            <td colspan="2">Contact: {{ data.ContactName }}</td>
             <td></td><td></td><td></td>
              <td colspan="2">Currency: {{data.Currency }} ({{ data.CurrencyID === 22 ? '€' : '£' }})</td>
        </tr>
        <!-- <tr>
            <td></td><td></td><td></td><td></td><td></td>
            <td colspan="2">Currency: {{data.Currency }} ({{ data.CurrencyID === 22 ? '€' : '£' }})</td>
        </tr> -->

        <tr>
            <td></td><td></td><td></td><td></td><td></td>
            <td colspan="2">VAT: {{ data.VATCode }}</td>
        </tr>
      
        <tr>
            <td colspan="2">Commodity: {{ data.Commodity }}</td>
        </tr>

        <tr></tr>
        <tr><td colspan="2">Brief Description of service to be performed: {{appService.deResingDoubleQuotess(data.DescriptionofService)}}</td></tr>
        <tr><td colspan="2">RA Volume Guarantees: {{appService.deResingDoubleQuotess(data.VolumeGuarantees)}}</td></tr>
        <tr><td colspan="2">Market Test: {{appService.deResingDoubleQuotess(data.MarketTest)}}</td></tr>

        <tr></tr><tr><td colspan="2">Rates: See rate tables sheets attached</td></tr>
        <tr></tr><tr><td colspan="2">Specification:{{appService.deResingDoubleQuotess(data.Specification)}}</td></tr>
        <tr></tr><tr><td colspan="2">Contract Duration: {{data.ContractDuration}} Years</td></tr>
        <tr><td colspan="2">Auto Extension: {{data.AutoExtensionFlag}}. {{appService.deResingDoubleQuotess(data.AutoExtensionComment)}}</td></tr>
        <tr></tr><tr><td colspan="2">Buyer Name: {{data['Buyer Name']}}</td></tr>

        <tr><td colspan="2">Email: {{data.BuyerEmail}}</td></tr>
        <tr><td colspan="2">Date: {{data.ModifiedOn?this.tableService.checkOnInvalidDate(data.ModifiedOn):''}}</td></tr>
        <tr><td colspan="2">Telephone: {{data.BuyerTelephone}}</td></tr>
        <tr><td colspan="2">Location: {{data.BuyerLocation}}</td></tr>
        <tr></tr><tr></tr>

        <!-- <tr><td colspan="2">Buyer Code: {{ data['BuyerCode']}}</td></tr> -->
        <tr>
            <td colspan="2">GIS2 Classification: {{data.GISClassification}}</td> 
            <td></td><td></td><td></td>
            <td colspan="2">Date Issued: {{data.CreatedOn | date:'dd/MM/yyyy' }}</td> 
        </tr>
        <tr>
            <td colspan="2">GIS1 Item Number: {{data.GISNumber}}</td>
            <td></td><td></td><td></td>
            <td colspan="2">Date Revised: {{data.ModifiedOn | date:'dd/MM/yyyy' }}</td> 
        </tr>

        <tr></tr>
        <tr><td></td><td colspan="6">The Carrier/Provider will sell and deliver the services as specified in the Service Contract</td></tr>
        <tr><td></td><td colspan="6">and in accordance to the Master Service Agreement</td></tr>
    </table>
    
    <div style="width: 80vw;margin: auto;" *ngIf="exportPDFTableList&&exportPDFTableList.length>0">
        <hr>
        <br><br>
        @for(i of exportPDFTableList; track $index){
            <app-export-pdf-ltl class="table-matrix-1" *ngIf="i?.type==='ltl'" type="excel" [data]="i"></app-export-pdf-ltl>
            <app-export-pdf-fixed class="table-matrix-1" *ngIf="i?.type==='fixed'" type="excel" [data]="i"></app-export-pdf-fixed>
            <app-export-pdf-table class="table-matrix-1" *ngIf="i?.type==='ftl'" type="excel" [data]="i"></app-export-pdf-table>
            <hr><br><br>
        }
    </div>

   
</div>
